module.exports = __webpack_public_path__ + "assets/img/Inter-ExtraLight.svg?367d28876ca783929b0ba0af17eb3f98";